export default {
  install(app) {
    // 驗證手機號碼
    app.config.globalProperties.$validatePhone = function (phone) {
      return /^09\d{8}$/.test(phone)
    }

    // 驗證證號
    app.config.globalProperties.$validateId = function (personId) {
      return (
        isNationalIdNumberValid(personId) ||
        isNewResidenceNumberValid(personId) ||
        isOldResidenceNumberValid(personId)
      )
    }

    const countyCode = {
      A: '10',
      B: '11',
      C: '12',
      D: '13',
      E: '14',
      F: '15',
      G: '16',
      H: '17',
      I: '34',
      J: '18',
      K: '19',
      L: '20',
      M: '21',
      N: '22',
      O: '35',
      P: '23',
      Q: '24',
      R: '25',
      S: '26',
      T: '27',
      U: '28',
      V: '29',
      W: '32',
      X: '30',
      Y: '31',
      Z: '33'
    }

    // 身分證號驗證
    function isNationalIdNumberValid(id) {
      const regex = /^([A-Z])[1,2]\d{8}$/
      if (typeof id !== 'string') return false
      if (!regex.test(id)) return false

      const county = id.match(regex)[1]
      const code = id.replace(county, countyCode[county])

      const multiplier = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]
      const evaluateValue = code
        .split('')
        .reduce((prev, curr, idx) => prev + curr * multiplier[idx], 0)

      return evaluateValue % 10 === 0
    }

    // 新制居留證號驗證
    function isNewResidenceNumberValid(id) {
      const regex = /^([A-Z])[8,9]\d{8}$/
      if (typeof id !== 'string') return false
      if (!regex.test(id)) return false

      const county = id.match(regex)[1]
      const code = id.replace(county, countyCode[county])

      const codeArr = code.split('').map((c) => parseInt(c, 10))
      const evaluationValue = codeArr.splice(-1, 1)[0]
      const multiplier = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1]
      const base = codeArr.reduce((prev, curr, idx) => prev + ((curr * multiplier[idx]) % 10), 0)
      const evaluationCode = base % 10 === 0 ? 0 : 10 - (base % 10)

      return evaluationCode === evaluationValue
    }

    // 舊制居留證號驗證
    function isOldResidenceNumberValid(id) {
      const regex = /^([A-Z])([A,B,C,D])\d{8}$/
      if (typeof id !== 'string') return false
      if (!regex.test(id)) return false

      const county = id.match(regex)[1]
      const sex = id.match(regex)[2]
      const code = id.replace(
        `${county}${sex}`,
        `${countyCode[county]}${parseInt(countyCode[sex], 10) % 10}`
      )

      const multiplier = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]
      const evaluateValue = code
        .split('')
        .reduce((prev, curr, idx) => prev + curr * multiplier[idx], 0)

      return evaluateValue % 10 === 0
    }
  }
}
